export default __webpack_public_path__ + "static/media/book-nav-icon1-hover.070c9eab.svg";